module.exports = __webpack_public_path__ + "img/0051.97a09bb5.gif";